import { Component } from '@angular/core';
import { AppComponentBase } from '@bling-fe/shared/core/core/app-component.base';
import { LoadCurrentEventsFiltersAction } from '@bling-fe/shared/core/core/states/events-state/events.actions';

@Component({
  selector: 'fl-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent extends AppComponentBase {
  protected override dispatchStartupActions(): void {
    super.dispatchStartupActions();
    this.store.dispatch(new LoadCurrentEventsFiltersAction());
  }
}
